
































import Vue from "vue";
import { IncorrectInventoryPayLoad } from "../models/ErrorTrackingIncorrectInventory";
export default Vue.extend({
  props: {
    value: {
      type: Array as () => IncorrectInventoryPayLoad[]
    }
  },
  computed: {
    incorrectInventories: {
      get(): IncorrectInventoryPayLoad[] {
        return (this as any).value;
      }
    },
    hasIncorrectInventories() {
      return (this as any).incorrectInventories.length;
    }
  }
});
